"use client";

import Script from "next/script";
import { useCookieConsent } from "@/contexts/CookieConsentContext";

const GA_MEASUREMENT_ID = process.env.NEXT_PUBLIC_GA_MEASUREMENT_ID;

/**
 * Loads Google Analytics (gtag.js) only when the user has accepted analytics cookies.
 * Set NEXT_PUBLIC_GA_MEASUREMENT_ID (e.g. G-0LTQEQTJ4S) in your environment.
 */
export function GoogleAnalytics() {
  const { consent, ready } = useCookieConsent();

  if (!GA_MEASUREMENT_ID || !ready || !consent?.analytics) {
    return null;
  }

  const gtagInit = `
    window.dataLayer = window.dataLayer || [];
    function gtag(){dataLayer.push(arguments);}
    gtag('js', new Date());
    gtag('config', '${GA_MEASUREMENT_ID}');
  `;

  return (
    <>
      <Script
        src={`https://www.googletagmanager.com/gtag/js?id=${GA_MEASUREMENT_ID}`}
        strategy="afterInteractive"
      />
      <Script id="gtag-init" strategy="afterInteractive">
        {gtagInit}
      </Script>
    </>
  );
}
